import crypto from 'crypto-js';

const tokenKey = 'id_token';
const loginKey = 'login_token';

/**
 * 유저의 인증과 관련된 credential을 관리하기 위한 서비스
 */
const authService = {
  isAuthenticated(): boolean {
    return !!this.getCredential();
  },
  getCredential() {
    return window.localStorage.getItem(tokenKey);
  },
  setCredential(credential: string): void {
    window.localStorage.setItem(tokenKey, credential);
  },
  removeCredential(): void {
    window.localStorage.removeItem(tokenKey);
    window.localStorage.removeItem(loginKey);
  },
  saveCredential(id: string, pw: string): void {
    const cipherId = crypto.AES.encrypt(id, loginKey).toString();
    const cipherPw = crypto.AES.encrypt(pw, loginKey).toString();
    const cipherJson = crypto.AES.encrypt(JSON.stringify({ id: cipherId, pw: cipherPw }), loginKey).toString();

    window.localStorage.setItem(loginKey, cipherJson);
  },
  restoreCredential(): { id: string; pw: string } | null {
    const data = window.localStorage.getItem(loginKey);
    if (data) {
      const bytesData = crypto.AES.decrypt(data, loginKey);
      const originalData = bytesData.toString(crypto.enc.Utf8);
      const loginData = JSON.parse(originalData) as { id: string; pw: string; };
      const bytesId = crypto.AES.decrypt(loginData.id, loginKey);
      const originalId = bytesId.toString(crypto.enc.Utf8);
      const bytesPw = crypto.AES.decrypt(loginData.pw, loginKey);
      const originalPw = bytesPw.toString(crypto.enc.Utf8);
      return { id: originalId, pw: originalPw };
    }
    return null;
  }
};

/**
 * Singleton
 */
export default authService;
